<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
          <md-button
                  href="https://twitter.com/iamjoeyshark"
                  class="md-just-icon md-simple"
          >
            <i class="fab fa-twitter"></i>
          </md-button>
          <md-button
                  href="https://www.facebook.com/iamjoeyshark"
                  class="md-just-icon md-simple"
          >
            <i class="fab fa-instagram"></i>
          </md-button>
          <md-button
                  href="https://www.instagram.com/iamjoeyshark"
                  class="md-just-icon md-simple"
          >
            <i class="fab fa-facebook-square"></i>
          </md-button>
      </nav>

      <div class="copyright">
        &copy; {{ year }} I Am Joey Shark, kudos to <a href="https://www.creative-tim.com/" target="_blank">Creative Tim</a> for base theme.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
